import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';

import HelpIcon from '@/assets/images/icons/help-icon.svg';
import MailIcon from '@/assets/images/icons/MFO-main-logo-White.png';
import RightIcon from '@/assets/images/icons/right-icon.svg';
import { HelpPageSEO } from '@/utils/constants/MetaData';

const Help = () => {
  return (
    <>
      <Head>
        <title>{HelpPageSEO.metaTitle}</title>
        <meta name="description" content={HelpPageSEO.metaDescription} />
        <meta
          property="og:description"
          content={HelpPageSEO.metaOGDescription}
        />
        <link rel="canonical" href="https://muthootfincorpone.com/help/" />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <h1> Help & Support</h1>
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard">
            <p className="loanCard__title text--bold text--black">
              Frequently Asked Questions
            </p>
            <ul
              className="nav nav-tabs horizontal-tab"
              id="ordersTab"
              role="tablist"
            >
              <li className="nav-item">
                <a
                  className="nav-link active"
                  id="goldLoan-tab"
                  data-toggle="tab"
                  href="#goldLoan"
                  role="tab"
                  aria-controls="goldLoan"
                  aria-selected="true"
                >
                  Gold Loan
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="eSwarnaDigitalGold-tab"
                  data-toggle="tab"
                  href="#eSwarnaDigitalGold"
                  role="tab"
                  aria-controls="eSwarnaDigitalGold"
                  aria-selected="false"
                >
                  eSwarna Digital Gold
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  id="forex-tab"
                  data-toggle="tab"
                  href="#forex"
                  role="tab"
                  aria-controls="forex"
                  aria-selected="false"
                >
                  Forex
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  id="ncd-tab"
                  data-toggle="tab"
                  href="#ncd"
                  role="tab"
                  aria-controls="ncd"
                  aria-selected="false"
                >
                  NCD
                </a>
              </li>
              {/* <li className="nav-item">
              <Link
                className="nav-link"
                id="aboutOne-tab"
                data-toggle="tab"
                href="#aboutOne"
                role="tab"
                aria-controls="aboutOne"
                aria-selected="false"
              >
                About ONE Muthoot
              </Link>
            </li> */}
            </ul>
            <div className="tab-content" id="myOrderContent">
              <div
                className="tab-pane fade show active"
                id="goldLoan"
                role="tabpanel"
                aria-labelledby="goldLoan-tab"
              >
                <div className="help__links__container">
                  <Link
                    className="help__links"
                    href="/help/gold-loans/about-gold-loan-from-home"
                  >
                    <p className="text--black text--semi">
                      About Gold Loan Prime
                    </p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link
                    className="help__links"
                    href="/help/gold-loans/gold-loan-from-home-application-process"
                  >
                    <p className="text--black text--semi">
                      Gold Loan Prime Application Process
                    </p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link
                    className="help__links"
                    href="/help/gold-loans/safety-of-glfh"
                  >
                    <p className="text--black text--semi">
                      Safety of Gold Loan Prime
                    </p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="eSwarnaDigitalGold"
                role="tabpanel"
                aria-labelledby="eSwarnaDigitalGold-tab"
              >
                <div className="help__links__container">
                  <Link
                    className="help__links"
                    href="/help/eSwarna-digital-gold/general"
                  >
                    <p className="text--black text--semi">General</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link
                    className="help__links"
                    href="/help/eSwarna-digital-gold/buy-sell"
                  >
                    <p className="text--black text--semi">Buy/Sell</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link
                    className="help__links"
                    href="/help/eSwarna-digital-gold/sip"
                  >
                    <p className="text--black text--semi">SIP</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link
                    className="help__links"
                    href="/help/eSwarna-digital-gold/coupons"
                  >
                    <p className="text--black text--semi">Coupons</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link
                    className="help__links"
                    href="/help/eSwarna-digital-gold/gift-gold"
                  >
                    <p className="text--black text--semi">Gift Gold</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                </div>
              </div>
              {/* <div
              className="tab-pane fade"
              id="billPayment"
              role="tabpanel"
              aria-labelledby="billPayment-tab"
            >
              <div className="help__links__container">
                <Link className="help__links" href="/help/forex/general">
                  <p className="text--black text--semi">General</p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
                <Link className="help__links" href="/help/forex/forex-cards">
                  <p className="text--black text--semi">Forex cards</p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
                <Link className="help__links" href="/help/forex/buy-forex">
                  <p className="text--black text--semi">Buy Forex Currency</p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
                <Link className="help__links" href="/help/forex/sell-forex">
                  <p className="text--black text--semi">Sell Forex Currency</p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
                <Link
                  className="help__links"
                  href="/help/forex/outward-remittances"
                >
                  <p className="text--black text--semi">Outward Remittances</p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
              </div>
            </div> */}
              <div
                className="tab-pane fade"
                id="ncd"
                role="tabpanel"
                aria-labelledby="ncd-tab"
              >
                <div className="help__links__container">
                  <Link className="help__links" href="/help/ncd/general">
                    <p className="text--black text--semi">General</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="forex"
                role="tabpanel"
                aria-labelledby="forex-tab"
              >
                <div className="help__links__container">
                  <Link className="help__links" href="/help/forex/general">
                    <p className="text--black text--semi">General</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link className="help__links" href="/help/forex/forex-cards">
                    <p className="text--black text--semi">Forex cards</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link className="help__links" href="/help/forex/buy-forex">
                    <p className="text--black text--semi">Buy Forex Currency</p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link className="help__links" href="/help/forex/sell-forex">
                    <p className="text--black text--semi">
                      Sell Forex Currency
                    </p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                  <Link
                    className="help__links"
                    href="/help/forex/outward-remittances"
                  >
                    <p className="text--black text--semi">
                      Outward Remittances
                    </p>
                    <Image
                      style={{ color: undefined }}
                      className="d-flex"
                      src={RightIcon}
                      alt="right"
                    />
                  </Link>
                </div>
              </div>

              {/* <div
              className="tab-pane fade"
              id="aboutOne"
              role="tabpanel"
              aria-labelledby="aboutOne-tab"
            >
              <div className="help__links__container">
                <Link className="help__links" href="./help-faq.html">
                  <p className="text--black text--semi">
                    About ONE Muthoot Digital Gold
                  </p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
                <Link className="help__links" href="./help-faq.html">
                  <p className="text--black text--semi">
                    Gold purity & live price
                  </p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
                <Link className="help__links" href="./help-faq.html">
                  <p className="text--black text--semi">Buying Gold</p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
                <Link className="help__links" href="./help-faq.html">
                  <p className="text--black text--semi">SIP</p>
                  <Image style={{color:undefined}} className="d-flex" src={RightIcon} alt="right" />
                </Link>
              </div>
            </div> */}
            </div>
          </div>

          <div className="loanDetails__card loanCard">
            <div className="helpContact">
              <div className="phone">
                <Image
                  style={{ color: undefined }}
                  src={HelpIcon}
                  alt="help icon"
                />
                <div className="text--black text--bold">
                  <h2>Contact Us</h2>{' '}
                  {/* <span className="text--black text--semi">1800 0800 8800</span> */}
                  <span>
                    <Link
                      className="text--black text--semi"
                      href="tel:1800-102-1616"
                    >
                      1800-102-1616
                    </Link>
                  </span>
                </div>
              </div>
              <div className="email">
                <Image
                  style={{ color: undefined }}
                  src={MailIcon}
                  alt="mail icon"
                />
                <p className="text--black text--bold">
                  Email Us{' '}
                  {/* <span className="text--black text--semi">
                  support@onemuthoot.com
                </span> */}
                  <span>
                    <Link
                      className="text--black text--semi"
                      href="mailto:customercare@muthoot.com"
                    >
                      customercare@muthoot.com
                    </Link>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
export default Help;
